import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

// app/javascript/packs/application.js
import 'bootstrap';
import "./risk_maps"
import "./strategic_risk_contexts"
import "./strategic_objective_risks"
import "./poas"
import "../chat"
import "../notifications"
import "../oauth_applications"
import "../poa_import_dependencies"
import "./app-globals"
import "./bulk_notifications"
import "./jquery.mask"
import "../request-throttling"
import $ from "jquery";
Rails.start()
Turbolinks.start()
ActiveStorage.start()

$(document).ready(function(){
    $("#loading").hide();
});

$(document).on('submit', 'form', function(event) {
    if ($(this).hasClass('skip-loading')) return;
    if ($(event.target).closest('#system-chat').length) return;
    const originalEvent = event.originalEvent;
    const submitter = originalEvent && originalEvent.submitter;

    if (submitter && $(submitter).hasClass('skip-loading')) {
        $('#loading').hide();
        return;
    }

    $('#loading').show();
});

$(document).on('click', 'a, button', function(event) {
    if ($(this).hasClass('skip-loading')) return;
    if ($(event.target).closest('#system-chat').length) return;
    if (!event.metaKey && !event.ctrlKey &&
        !$(event.target).closest('button[type="submit"], button:not([type]), input[type="submit"]').length &&
        !$(event.target).closest('.btn-close, .nav-link, .navbar-toggler, .dropdown-toggle, #toTop, .skip-loading, .bi-file-earmark-spreadsheet, [data-bs-toggle="modal"], [data-bs-dismiss="modal"]').length) {
        $('#loading').show();
    }
});

// Se usa un botón en lugar de un enlace para que Turbolinks no navegue a la
// URL mostrada después de previsualizar una importación de POA.
$(document).on('click', '#toBottom', function(event) {
    event.preventDefault();
    window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: 'smooth'
    });
});

// Eventos de Turbolinks
document.addEventListener("turbolinks:request-start", function() {
    $('#loading').show(); // Muestra el loading al iniciar una solicitud de Turbolinks
});

document.addEventListener("turbolinks:load", function() {
    $('#loading').hide(); // Oculta el loading cuando la página se ha cargado completamente
});

document.addEventListener("turbolinks:before-cache", function() {
    $('#loading').hide(); // Asegúrate de ocultar el loading antes de almacenar en caché la página
});

// Manejo de la navegación con el botón atrás/adelante
window.addEventListener('popstate', function() {
    $('#loading').hide(); // Ocultar el loading al usar el botón de atrás o adelante
});

// Fallback en caso de que `load` sea necesario
$(window).on('load', function() {
    $('#loading').hide();
});

$(window).bind("beforeunload",function(event){
    $("#loading").show();
});

// Las páginas privadas restauradas desde el historial deben comprobarse otra
// vez: pueden pertenecer a una sesión vencida o a otra cuenta del navegador.
window.addEventListener("pageshow", (event) => {
    if (event.persisted) window.location.reload();
});

function goToSignIn(expired) {
    if (window.location.pathname === "/users/sign_in") return;
    window.location.assign(expired ? "/users/sign_in?sesion=expirada" : "/users/sign_in");
}

async function checkSession() {
    const marker = document.querySelector('meta[name="session-user"]');
    // Las páginas públicas no tienen una identidad que comprobar.
    if (!marker || !marker.content) return;

    try {
        const response = await fetch("/session_status", {
            cache: "no-store",
            credentials: "same-origin",
            // Evita que Devise guarde el sondeo como destino para después del login.
            headers: { "X-Requested-With": "XMLHttpRequest" }
        });
        if (response.redirected || response.status === 401) {
            goToSignIn(true);
            return;
        }
        if (!response.ok) return;

        const status = await response.json();
        if (String(status.user_id || "") !== marker.content) window.location.reload();
    } catch (_) {
        // La siguiente navegación o comprobación reintentará cuando vuelva la red.
    }
}

document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") checkSession();
});

setInterval(checkSession, 60000);

// Una petición AJAX privada con 401 no debe fallar silenciosamente.
$(document).ajaxError((_event, xhr) => {
    if (xhr.status === 401) goToSignIn(true);
});
